module.exports = __webpack_public_path__ + "img/UT0372.7f3a305b.png";